var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 96,
    viewBox: "0 0 95 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5004 8C23.6832 8 5.97656 25.92 5.97656 48C5.97656 70.08 23.6832 88 45.5004 88C67.3175 88 85.0242 70.08 85.0242 48C85.0242 25.92 67.3175 8 45.5004 8ZM37.5956 66V30L61.3099 48L37.5956 66Z",
    fill: "url(#paint0_radial_185_625)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_185_625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.5004 48) rotate(90) scale(40 39.5238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C338D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.8571,
    height: 96,
    fill: "white",
    transform: "translate(0.0478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play_circle.e91831f3f6df2fc45c99e35072ceb10a.svg";
export { ForwardRef as ReactComponent };